import {DotPath} from '../getOrElse'
import {merge} from 'lodash'
import {getDefinedOrElse} from './getter'
import {Decorators} from '../config/getterConfig'
import {decorate} from './decorator'

/**
 * A note for the user:
 *  Since TS is transpiled no type info is available at runtime,
 *  meaning that without a default orElse, you will get an
 *  EMPTY json object ({}) so things will be kind of broken.
 *
 * USE WITH EXTREME CAUTION
 *
 * @param root root object
 * @param path path to field
 * @param orElse should be provided or you will get an empty object
 * and things will be borked
 */
export function objectOr<T extends {[index: string]: any}>(
  root: object,
  path: DotPath = '',
  decorators: Decorators<T> = [],
  orElse = {} as T
): T {
  return merge(
    {},
    orElse,
    decorate(getDefinedOrElse(root, path, orElse), decorators)
  )
}